import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AttorneyService } from 'src/app/services/attorney.service';
import { ImagilityBaseResponse } from '../../../data/models/response.model';
import { AttorneyConnect } from '../../../data/models/attorney.model';
import { MarkDirtyFormAction, MarkCleanFormAction } from './../../../app-state/actions/dirty-form.actions';

@Component({
  selector: 'app-client-connection',
  templateUrl: './client-connection.component.html',
  styleUrls: ['./client-connection.component.scss']
})
export class ClientConnectionComponent implements OnInit, AfterViewInit, OnDestroy {

  attorney = new AttorneyConnect({
    emailId: '',
    firstName: '',
    lastName: '',
    middleName: '',
    note: ''
  });
  attorneys;
  attorneyId: number;
  @ViewChild('f', { static: false }) clientConnectionForm: NgForm;
  formChangesSubscription: Subscription;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private attorneyService: AttorneyService,
    private route: ActivatedRoute,
    protected store: Store<any>) { }

  ngOnInit() {
    this.attorneyService.getAttorneys('PETNR').subscribe(data => {
      this.attorneys = data;
    });
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.clientConnectionForm.statusChanges.subscribe(() => {
      if (this.clientConnectionForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({ dirty: true }));
      } else {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
      }
    });
  }

  attorneyConnectFormSub() {
    // IM-3598
    for (const key in this.attorney) {
      if (this.attorney.hasOwnProperty(key)) {
        this.attorney[key] = this.attorney[key].trim();
      }
    }
    this.attorneyService.attorneyConnect(this.attorneyId, parseInt(sessionStorage.getItem('companyId')), this.attorney)
      .subscribe((response: ImagilityBaseResponse) => {
        if (response) {
          this.clientConnectionForm.reset(this.clientConnectionForm.value);
          this.toastr.success(response.message, 'Success');
          this.router.navigate(['../clients'], { relativeTo: this.route });
        }
      });
  }

  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }
}
